/**
 * チャートの GC 縦線のコマ。
 *
 * どのコマが次に GC を迎えるかは、page 応答の backend の GC 境界
 * (`gate_close_frontier`) を `~/models/gateClose` で現在時刻まで進めて求める。ここでは
 * 壁時計から GC コマを再計算しない (GC の余裕時間・日跨ぎは backend の
 * `GateCloseFrontier` だけが持つ)。当日断面だけで使う (呼び出し側が対象日 = JST の今日で
 * gate する)。
 */
import type { CivilDate } from '~/models/civilDate'
import { now as serverNow } from '~/models/clock'
import type { GateCloseFrontier } from '~/models/gateClose'
import { gateCloseCountdownOn } from '~/models/gateClose'

/**
 * チャートの GC 縦線を置くコマ番号 (AC-DFD-006a-5)。
 *
 * 画面上部の GC カウントダウン (AC-DFC-CD-001、`components/GcCountdown`) が示す
 * 「次にロックされるコマ」と同じ値を返す (両方とも [[gateCloseCountdownOn]] の
 * `counting` のコマ。線より左 = ロック済みのコマ。design forecast-today.html の
 * `GC_KOMA` はチップとチャート縦線の両方が同じ値を参照する)。本日分の GC がすべて
 * 済んだ後は線を置くコマが無いので undefined。
 */
export function chartGcLineKoma(
  frontier: GateCloseFrontier,
  targetDate: CivilDate,
  now: Date = serverNow(),
): number | undefined {
  const countdown = gateCloseCountdownOn(frontier, targetDate, now)
  return countdown.status === 'counting' ? countdown.koma : undefined
}
